import { render, staticRenderFns } from "./zoumadeng.vue?vue&type=template&id=460bb922&scoped=true&"
import script from "./zoumadeng.vue?vue&type=script&lang=js&"
export * from "./zoumadeng.vue?vue&type=script&lang=js&"
import style0 from "./zoumadeng.vue?vue&type=style&index=0&id=460bb922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bb922",
  null
  
)

export default component.exports